module.exports = __webpack_public_path__ + "a0b3bb5da1b3d636b45012ab5c576a55.ttf";